import Vue from "vue";
import BootstrapVue, { IconsPlugin } from "bootstrap-vue";
import "@/assets/style/vendor/bootstrap.css";
import "@/assets/style/vendor/bootstrap.rtl.only.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
